import type { Security } from '../../types/Security';
import { SecurityTypesUtils } from '../../types/SecurityTypes';
import { hasMarketBrandLogo, resolvePredictionCardLogoMarket } from '../MarketLogos';

/**
 * Chooses the venue whose logo replaces the currency icon on a security row.
 * Only product types listed here use a market logo; everything else returns
 * undefined so the currency icon stays in place. Prefers the venue the row was
 * actually traded on, then any listed venue we have a logo for — outcomes are
 * also listed on venues that are not prediction markets, and those must not win
 * over Kalshi. Falls back to the `KX` symbol prefix.
 */
export function resolveSecurityMarketLogo({
  security,
  tradedMarket,
}: {
  security?: Security;
  tradedMarket?: string;
}): string | undefined {
  const usesMarketLogo = SecurityTypesUtils.PredictionOutcome.isProductType(security);
  if (!usesMarketLogo) {
    return undefined;
  }

  const venue = [tradedMarket, ...(security?.Markets ?? [])].find(hasMarketBrandLogo);
  return resolvePredictionCardLogoMarket(venue, security?.Symbol);
}
